import { DEFAULT_STATE } from '../constants'

export const initialAssetTypeState = {
  assetType: DEFAULT_STATE.assetType,
}
